import { Box, styled, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";

function WrapperMarketPrice({ data }) {
  return (
    <BoxWrapper>
      <Box display="flex" marginBottom={1}>
        <Typography
          variant="h6"
          component="span"
          color="secondary.main"
          fontWeight={600}
        >
          <NumberFormats value={data?.priceMarketUSDT} />
        </Typography>
        <Typography variant="h6" component="span" marginLeft={1}>
          USDT
        </Typography>
      </Box>

      <Box>
        <Typography
          variant="h6"
          component="span"
          color="secondary.main"
          fontWeight={600}
        >
          <NumberFormats value={data?.priceMarketToman} />
        </Typography>
        <Typography variant="h6" component="span" marginLeft={1}>
          TOMAN
        </Typography>
      </Box>
    </BoxWrapper>
  );
}

const BoxWrapper = styled(Box)(() => ({
  cursor: "pointer",
}));

export default WrapperMarketPrice;
